import { Link } from 'react-router-dom';
import { articles, categories } from '@/mocks/articles';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Elegant%20Japanese%20aesthetic%20abstract%20background%20with%20soft%20warm%20cream%20tones%20subtle%20cherry%20blossom%20motif%20minimalist%20composition%20artistic%20atmosphere%20gentle%20gradients%20sophisticated%20editorial%20style%20clean%20serene%20modern%20Japanese%20design&width=1600&height=900&seq=sayama-hero-bg&orientation=landscape"
        alt="佐山爱"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/15 to-black/35"></div>

      <div className="absolute inset-0 flex flex-col items-center justify-center w-full px-4 md:px-6">
        <div className="text-center max-w-2xl">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/20 mb-6">
            <i className="ri-sparkling-line text-sm text-background-50"></i>
            <span className="text-xs font-label text-background-50">最全面的中文信息平台</span>
          </div>
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-4 leading-tight">
            佐山爱
          </h1>
          <p className="text-sm md:text-base text-background-50/80 font-body leading-relaxed max-w-lg mx-auto mb-8">
            日本知名女演员及写真偶像，本页汇总佐山爱的个人资料、出道经历、代表作品及最新动态
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/profile"
              className="whitespace-nowrap cursor-pointer px-6 py-3 bg-primary-500 text-background-50 rounded-lg text-sm font-label hover:bg-primary-600 transition-colors"
            >
              <i className="ri-user-heart-line mr-2"></i>查看个人资料
            </Link>
            <Link
              to="/category/gravure"
              className="whitespace-nowrap cursor-pointer px-6 py-3 bg-background-50/15 backdrop-blur-sm text-background-50 border border-background-50/25 rounded-lg text-sm font-label hover:bg-background-50/25 transition-colors"
            >
              <i className="ri-camera-lens-line mr-2"></i>浏览写真作品
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2">
        <div className="w-6 h-10 rounded-full border-2 border-background-50/30 flex items-start justify-center">
          <div className="w-1.5 h-1.5 rounded-full bg-background-50/50 mt-2 animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}